window.$parsley, window.$form;
var recaptchaLastTokenTimestamp = 0;

$(window).on('js-onload', function(){

    window.$form = $('#checkout-form');

    if(window.$form.length > 0) {
        initForm( initParsley );
        initCheckoutTabs( initHashTab );

        if(window.paypal_enabled) {
          initPayPal();
        }
    }
});



function initForm(callback) {
    // $('.prevent-duplicate').preventDoubleSubmission();

    window.$form.preventReturnSubmit({child: ':input, :button'});

    window.$form
        .on('click', '.prev-step, .next-step', function(event){
            event.preventDefault();

            var $me = $(this);
            var dir = $me.hasClass('next-step') ? 1 : -1;
            var $current = $('#checkout-tabs').find('li.active:first');

            // next
            if(dir > 0) {
                if(!validatePanel( $me.closest('.checkout-panel').attr('id') )) {
                    return false;
                }
                $current.next('li').find('a:first').tab('show');

                $(window).trigger('next.step', [
                    $current.find('a:first').attr('href'),
                    $current.next('li').find('a:first').attr('href')
                ]);

                var rateOption = window.$shipRates.find(':checked:first').parent().find('.first-element-inner:first').text();

                if(!!window.google_tag_manager) {
                    window.checkoutStep(2, rateOption);
                }
                return;
            }

            // previous
            $current.prev('li').find('a:first').tab('show');

            $(window).trigger('prev.step', [
                $current.find('a:first').attr('href'),
                $current.prev('li').find('a:first').attr('href')
            ]);
        })

        .on('click', '.edit-step', function(event){
            var href = $(this).attr('href');
            if(href.indexOf('#') == 0) {
                event.preventDefault();
                var $step = $('.checkout-tabs [href="'+href+'-panel"]:first');

                $(window).trigger('edit.step', [
                    $('#checkout-tabs').find('li.active:first').find('a:first').attr('href'),
                    $step.attr('href')
                ]);

                $step.tab('show');
            }
        })

        .on('change', '#cc-exp-month', function(){
            $('#cc-exp-year').parsley().validate();
        })

        .on('submit', function(event){
            event.preventDefault();
            var $btn = $form.find('[type="submit"]');

            $btn.disable().addClass('loading');

            $(this).find('.alert').remove();

            appendShipRateFields();

            if(validatePanel()) {
                if($('#payment-method--paypal').prop('checked') === true) {
                    window.checkoutStep(3, 'PayPal');

                    window.$form[0].submit();

                    return;
                }

                var card = $('[name="payment_card"]:checked:first');
                var cardType = (!card.length || card.val() === 'new')
                    ? getCardType($('#cardnumber').val()).name.toUpperCase()
                    : $('[name="payment_card"]:checked:first').attr('data-card-type');

                if(!!window.google_tag_manager) {
                    window.checkoutStep(3, cardType);
                }

                var thisForm = this;

                window.attempts++;
                if(window.attempts < process.env.MIX_CHECKOUT_ATTEMPT_LIMIT) {
                  checkoutSubmit.call(thisForm, event);

                  return;
                }

                if(typeof grecaptcha === 'undefined') {
                  $form.prependAlert('We were unable to verify your request. Your order was not submitted and your payment method has not been charged. Please reload and try again.<br><br>If this condition persists, please call <nobr><a class="text-bold text-error" href="tel:8002826631">800-282-6631</a></nobr> to place your order.', 'error');

                  $('html, body').delay(250).animate({
                      scrollTop: $('.alert:first').offset().top - 20
                  }, 350);

                  $btn.enable().removeClass('loading');
                  return;
                }

                var nowTimestamp = new Date().getTime();

                if(
                  (nowTimestamp - recaptchaLastTokenTimestamp) > 100000
                  || !document.getElementById('g-response').value
                ) {
                  grecaptcha.ready(function(){
                    grecaptcha.execute(
                        process.env.MIX_RECAPTCHA_KEY,
                        {action: 'checkout_submit'}
                    ).then(function(token) {
                        document.getElementById('g-response').value = token;

                        recaptchaLastTokenTimestamp = new Date().getTime();

                        checkoutSubmit.call(thisForm, event);
                    });
                  });
                } else {
                  checkoutSubmit.call(thisForm, event);
                }

                return;
            }

            $btn.enable().removeClass('loading');
        });


    if(typeof callback === 'function') {
        callback.call(null);
    }
}

function initParsley() {
    window.$parsley = window.$form.parsley({
        excluded: 'input[type=button], input[type=submit], input[type=reset], input[type=hidden], [disabled]'
        // ,errorsMessagesDisabled: true
    }).on('form:error', function(){
        // only trigger on submit of form
        if(this.hasOwnProperty('submitEvent') && this.submitEvent !== undefined) {
            if(this.submitEvent.hasOwnProperty('type') && this.submitEvent.type == 'submit') {
                jumpToError(true);
            }
        }
    });

    if(window.paypal_enabled) {
      window.$parsley.on('form:validate', function(instance) {
        var $fieldInstance = getParsleyPaypalInstance();

        var errorName = 'paypal-auth-custom';

        $fieldInstance.removeError(errorName, {updateClass: true});

        if(
          $('#payment-method--paypal').prop('checked') === true &&
          $('#paypal-order-id').length !== 1
        ) {
          $fieldInstance.addError(errorName, {
            message: 'You must authorize with PayPal before submitting your order.',
            updateClass: true
          });

          instance.validationResult = false;

          jumpToError(true);
        }
      });
    }
}

function initCheckoutTabs(callback) {
    $('.checkout-tabs > li > a[role="tab"]').on('show.bs.tab', function(ev){
        var panel = $(this).attr('data-panel');

        if(window.location.hash.substr(1) === panel) {
          if($('.parsley-error, .parsley-errors-list:not(:empty)').length > 0) {
              $('html, body').animate({
                  scrollTop: $('.parsley-error, .parsley-errors-list:not(:empty)').first().offset().top - $('#global-header').height()
              }, 500);
          }
        } else {
            window.replaceHash(panel);

            // scroll to steps
            var $errors = $('.parsley-error, .parsley-errors-list:not(:empty)');
            var $jumpTo = $errors.length > 0 ? $errors.first() : $('#checkout-progress-steps-wrapper');

            $('html, body').animate({
                scrollTop: $jumpTo.offset().top - $('#global-header').height()
            }, 500);
        }

        var $current = $('#checkout-progress-steps-wrapper .checkout-step.'+panel+'-step')
        $current.addClass('current')
            .siblings('.current').removeClass('current');

        $current.prevUntil('.untracked')
            .addClass('completed');

        $current.nextAll('.checkout-steps-item')
            .removeClass('completed');
    });

    if(typeof callback === 'function') {
        callback.call(null);
    }
}

function initHashTab() {
    var hash = window.location.hash.slice(1);
    if(hash != '' && $('.checkout-tabs > li > a[data-panel="'+hash+'"]:first').length > 0) {
        if(hash === 'billing' && validatePanel('shipping-panel')) {
            $('.checkout-tabs [data-panel="'+hash+'"]').tab('show');
            $('#sidebar-shipping, #sidebar-method').removeClass('hide');
        }
    }

    if($('.parsley-error:first').length > 0) {
        jumpToError(true);
    }

    $('html').toggleClass('checkout-tabs-init', true);
}

function initPayPal() {
    paypal.Buttons({
      style: {
        color: 'blue',
        label: 'pay',
        shape: 'rect',
      },
      createOrder: function(data, actions) {
        $('#paypal-loading-container').show();
        $('#paypal-button-wrapper').hide();
        $('#paypal-order-id').remove();

        return actions.order.create({
            application_context: {
                landing_page: 'LOGIN',
                locale: 'en-US',
                shipping_preference: 'SET_PROVIDED_ADDRESS',
                user_action: 'CONTINUE',
            },
            purchase_units: [
                {
                    amount: {
                        currency_code: 'USD',
                        value: window.orderTotals.total,
                    },
                    shipping: {
                      name: {
                        full_name: [
                          window.address.ship.first_name,
                          window.address.ship.last_name,
                        ].join(' ')
                      },
                      address: {
                        address_line_1: window.address.ship.address1,
                        address_line_2: window.address.ship.address2,
                        admin_area_2: window.address.ship.city,
                        country_code: window.address.ship.country,
                        postal_code: window.address.ship.postal_code,
                        admin_area_1: window.address.ship.state_province,
                      },
                    },
                },
            ],
        });
      },
      fundingSource: paypal.FUNDING.PAYPAL,
      onApprove: function(data, actions) {

        $('<input>').attr({
          id: 'paypal-order-id',
          name: 'paypal-order-id',
          type: 'hidden',
          value: data.orderID,
        }).appendTo(window.$form);

        $('#authorized-container').show().html(
          '<div><strong>Authorized</strong></div>'
          + '<button class="edit-paypal-details button button-smaller button-clean button-link" style="padding:0; margin-top: .5em;">Edit PayPal details</button>'
        );

        $('#paypal-loading-container').hide();

        getParsleyPaypalInstance().removeError('paypal-auth-custom');
      },
      onCancel: function(data) {
        resetPayPal();
      },
      onError: function(err) {
        resetPayPal();

        window.console.log(err);
      },
    }).render('#paypal-button-container');

    window.$form.on('click', '.edit-paypal-details', resetPayPal);
}

window.resetPayPal = function() {
  $('#paypal-order-id').remove();
  $('#authorized-container').html('').hide();
  $('#paypal-loading-container').hide();
  $('#paypal-button-wrapper').show();
};

function jumpToError(trigger) {
    var id = $('.parsley-error:first').closest('.checkout-panel').attr('id');
    var tab = $('.checkout-tabs > li > a[href="#'+id+'"]:first');
        tab.tab('show');

    if(trigger !== undefined && trigger === true) {
        tab.trigger('show.bs.tab');

        return;
    }
}

function validatePanel(panel_id) {
    switch(panel_id) {
        case 'shipping-panel':
            if(window.$parsley.validate({group: 'shipping'})) {
                return true;
            }
            break;
        case 'billing-panel':
        default:
            return window.$parsley.validate();
    }


    return false;
}

function checkoutSubmit(event) {
    var $form = $(this);
    var $btn = $form.find('[type="submit"]');
    var data = $form.serializeJSON();
    var $promoBtns = $('.apply-promo:first, .remove-promo:first');

    if(!data.hasOwnProperty('g-recaptcha-response') || !data['g-recaptcha-response']) {
      data['g-recaptcha-response'] = document.getElementById('g-response').value;
    }

    // shipping rate
    // data['shiprate'] = window.$shipRates.find(':checked:first').data('method');

    $btn.disable().addClass('loading');
    $promoBtns.disable();

    $.post('/order_url', data, null, 'json')
        .fail(function(xhr){
            window.attempts = Number(xhr.getResponseHeader('x-checkout-attempts') || 1);

            var message = errorMessageFromXhr(xhr);

            $form.prependAlert(message, 'error');

            $btn.enable().removeClass('loading');
            $promoBtns.enable();

            recaptchaLastTokenTimestamp = 0;

            $('html, body').delay(250).animate({
              scrollTop: $('.alert:last').offset().top - 20
          }, 350);
        })
        .done(function(response){
            if(response.url !== undefined) {
                submitPayment(response.url);

                return;
            }

            $btn.enable().removeClass('loading');
            $promoBtns.enable();
        });
}

function submitPayment(processUrl) {
    var $ccForm = $('<form>').attr({
        action: processUrl,
        method: 'post'
    });

    if($('[name="payment_card"]').length === 0 || $('[name="payment_card"]:checked').val() === 'new') {
        $('<input>').attr({
            name: 'billing-cc-number',
            type: 'hidden',
            value: $('#cardnumber').val()
        }).appendTo($ccForm);

        $('<input>').attr({
            name: 'billing-cc-exp',
            type: 'hidden',
            value: $('#cc-exp-month').val() + $('#cc-exp-year').val().slice(-2)
        }).appendTo($ccForm);

        $('<input>').attr({
            name: 'cvv',
            type: 'hidden',
            value: $('#cc-cvc').val()
        }).appendTo($ccForm);
    } else {
        var cvv = $('[name="payment_card"]:checked:first').closest('label').next('.cvv-block').find(':input:first').val();
        $('<input>').attr({
            name: 'cvv',
            type: 'hidden',
            value: cvv
        }).appendTo($ccForm);
    }

    $('body').append($ccForm);
    $ccForm.submit();
}

function appendShipRateFields() {
  var rate = window.$shipRates.find(':checked:first').data('method');

  window.$form.find('input[type="hidden"][name^="shiprate["]').remove();

  $.each(rate, function(key, value) {
    $('<input>').attr({
      type: 'hidden',
      name: 'shiprate[' + key + ']',
      value: value
    }).appendTo(window.$form);
  });
}

window.getParsleyPaypalInstance = function() {
  return $('#paypal-error-helper').parsley({
      errorsContainer: '#paypal-error-container',
      errorTemplate: '<div class="alert alert-error" style="font-size:1.15em;line-height:1.25em;"></div>',
      errorsWrapper: '<div class="parsley-errors-list"></div>',
    }, window.$parsley);
}
